export const formatTime = (seconds: number) => {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`
}

export const startTimer = (
  timerRef: React.MutableRefObject<NodeJS.Timeout | null>,
  setRecordingTime: React.Dispatch<React.SetStateAction<number>>
) => {
  timerRef.current = setInterval(() => {
    setRecordingTime((prev) => prev + 1)
  }, 1000)
}

export const stopTimer = (timerRef: React.MutableRefObject<NodeJS.Timeout | null>) => {
  if (timerRef.current) {
    clearInterval(timerRef.current)
    timerRef.current = null
  }
}

export const checkMicrophonePermission = async (
  setPermissionStatus: React.Dispatch<React.SetStateAction<string>>
): Promise<string> => {
  try {
    if (navigator.permissions) {
      const permission = await navigator.permissions.query({ name: "microphone" as PermissionName })
      setPermissionStatus(permission.state)
      return permission.state
    }
    return "unknown"
  } catch (error) {
    console.error("Error checking microphone permission:", error)
    return "unknown"
  }
}

export const requestMicrophonePermission = async (
  setError: React.Dispatch<React.SetStateAction<string | null>>
): Promise<boolean> => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: {
        echoCancellation: true,
        noiseSuppression: true,
        sampleRate: 44100,
      },
    })

    stream.getTracks().forEach((track) => track.stop())
    return true
  } catch (error: any) {
    console.error("Permission request failed:", error)

    if (error.name === "NotAllowedError") {
      setError("Microphone access denied. Please allow microphone access in your browser settings and try again.")
    } else if (error.name === "NotFoundError") {
      setError("No microphone found. Please connect a microphone and try again.")
    } else if (error.name === "NotSupportedError") {
      setError("Microphone access is not supported in this browser.")
    } else {
      setError("Could not access microphone. Please check your browser settings and try again.")
    }

    return false
  }
}